import { jwtDecode } from 'jwt-decode';
import type { LDSingleKindContext } from 'launchdarkly-react-client-sdk';
import type { TokenUser } from '~/types/Auth';

export const anonymousUserContext: LDSingleKindContext = {
  kind: 'user',
  anonymous: true,
  key: 'shared-anonymous',
};

/**
 * Converts an authentication token to a LaunchDarkly context for user identification and targeting.
 *
 * @param token - JWT authentication token containing user information
 * @returns LDSingleKindContext - LaunchDarkly context with user attributes for targeting
 */
export const convertToLDIdentityContext = (token: string | null): LDSingleKindContext => {
  if (!token) {
    return anonymousUserContext;
  }

  try {
    const user = jwtDecode<TokenUser>(token);

    return {
      kind: 'user',
      key: user.sub,
      email: user.email,
      name: `${user.first_name} ${user.last_name}`,
      role: user.role_id,
      cin7SupplierId: user.cin7_supplier_id,
      anonymous: false,
    };
  } catch (error) {
    // If token decode fails, return anonymous context
    console.error('Failed to decode token for LD context:', error);
    return anonymousUserContext;
  }
};
